import React from "react";
import ResumeCard from "./ResumeCard";
import { motion } from "framer-motion";
import { useEducation } from "./useResumeData";

const pageTransitionVariants = {
  hidden: {
    x: "100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
    },
  },
  exit: {
    x: "-100vw",
    opacity: 0, // Added opacity fade out
  },
};

const Education = () => {
  const { education, isLoading } = useEducation();

  return (
    <motion.div
      variants={pageTransitionVariants}
      initial="hidden"
      animate="visible"
      className="pb-16"
    >
      <div className=" my-12 text-center font-primary text-gray-500 dark:text-lightText ">
        <p className=" mb-4 text-designColor opacity-95">2016 - 2024</p>
        <h2 className=" text-3xl font-bold capitalize sm:text-4xl">
          Education Quality
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:p-8">
        {isLoading ? (
          // Simple Skeleton Loading
          [1, 2].map((i) => (
            <div key={i} className="animate-pulse rounded-lg bg-gray-200 p-10 dark:bg-[#1a1f2e] h-60"></div>
          ))
        ) : (
          education?.map((item) => (
            <ResumeCard
              key={item.id}
              title={item.degree}
              subTitle={`${item.institution} (${item.year_range})`}
              result={item.grade}
              desc={item.description}
            />
          ))
        )}
      </div>
    </motion.div>
  );
};

export default Education;
